import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import {setSearchedCustomers} from '../../../../../setup/slices/AnavezneSlice'
import {KTSVG} from '../../../../../_metronic/helpers'

const CustomerSearch = () => {
  const [inputValue, setInputValue] = useState<string>('')

  const dispatch = useDispatch()
  const filteredCustomers = useSelector((state: RootState) => state.customers.filteredCustomers)

  useEffect(() => {
    dispatch(setSearchedCustomers(filteredCustomers))
    let lastCustomers = filteredCustomers
    lastCustomers = lastCustomers.filter((customer: any) => {
      const custNameMatches = customer.CustName.toLowerCase().includes(inputValue?.toLowerCase())
      const customerReferenceMatches = customer.Customerreference?.toString().includes(inputValue)
      const vergiNoMatches = customer.VergiNo?.toUpperCase().includes(inputValue.toUpperCase())

      return custNameMatches || customerReferenceMatches || vergiNoMatches
    })

    dispatch(setSearchedCustomers(lastCustomers))
  }, [dispatch, filteredCustomers, inputValue])

  return (
    <div className='pt-7 '>
      <label htmlFor='search' className='mb-2 fs-6 fw-bolder text-gray-700'>
        Müşteri Arama:{' '}
      </label>
      <form className='w-90 position-relative' autoComplete='off'>
        <input
          id='searchInput'
          type='text'
          className='form-control form-control-solid px-15 w-90'
          name='search'
          placeholder='Arama'
          value={inputValue}
          onChange={(e) => {
            e.preventDefault()
            setInputValue(e.target.value)
          }}
        />
        <KTSVG
          path='/media/icons/duotone/General/Search.svg'
          className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'
        />
      </form>
    </div>
  )
}

export default CustomerSearch
